import { IPermissionGroup } from '../models/permission-group.model';

export let permissionGroupsTestData: IPermissionGroup[] = [
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'SupplierManagement.XrayCenters.ReadAll',
                        id: '2a84516b-cef5-487b-8eb0-04212e04b89d'
                    },
                    {
                        englishName: 'SupplierManagement.XrayCenters.Read',
                        id: '6f312920-5957-4730-8a36-71e307815400'
                    },
                    {
                        englishName: 'SupplierManagement.XrayCenters.Update',
                        id: '10e47280-904f-41a0-9c6e-7b0dda0c1ace'
                    },
                    {
                        englishName: 'SupplierManagement.XrayCenters.DeActivate',
                        id: '8d81380d-0c73-49f7-8737-9b4ea16a5b4c'
                    },
                    {
                        englishName: 'SupplierManagement.XrayCenters.Create',
                        id: '71ff9e7d-eaec-45d2-9269-a9a5a971f392'
                    },
                    {
                        englishName: 'SupplierManagement.XrayCenters.Activate',
                        id: 'c5308992-9c15-4ec9-b6b3-bfb418d7b73c'
                    }
                ],
                permissionGroups: [],
                englishName: 'SupplierManagement.XrayCenters',
                id: 'd0ceba2d-5cbc-4802-967d-1ff240836f2e'
            },
            {
                permissions: [
                    {
                        englishName: 'SupplierManagement.Hospitals.Create',
                        id: '6ca56cf3-8d35-4afd-9f8f-2f65b45c55fb'
                    },
                    {
                        englishName: 'SupplierManagement.Hospitals.DeActivate',
                        id: 'c8439fb7-b710-4897-92cf-5518b55ada82'
                    },
                    {
                        englishName: 'SupplierManagement.Hospitals.Read',
                        id: '8ec19280-168f-4ddd-94bb-662d18019457'
                    },
                    {
                        englishName: 'SupplierManagement.Hospitals.ReadAll',
                        id: 'c4c83aa8-f1e6-4220-9fc5-ae49e640dd0e'
                    },
                    {
                        englishName: 'SupplierManagement.Hospitals.Activate',
                        id: '0492983c-9d72-4198-944a-f80d90b48c3e'
                    },
                    {
                        englishName: 'SupplierManagement.Hospitals.Update',
                        id: '15f9d7ca-70fa-45ec-afb7-fb40ba1c2244'
                    }
                ],
                permissionGroups: [],
                englishName: 'SupplierManagement.Hospitals',
                id: '1642ef06-77a3-460c-a327-2c467e9b170f'
            },
            {
                permissions: [
                    {
                        englishName: 'SupplierManagement.LabAnalysisCenters.Update',
                        id: 'f16c85e9-00c3-4977-81be-2a3fac5a6d38'
                    },
                    {
                        englishName: 'SupplierManagement.LabAnalysisCenters.ReadAll',
                        id: 'fca571fa-f612-4e09-856f-4951f6c9b996'
                    },
                    {
                        englishName: 'SupplierManagement.LabAnalysisCenters.Read',
                        id: '213eb2b1-8140-45c0-8f3b-598fbd74f7fd'
                    },
                    {
                        englishName: 'SupplierManagement.LabAnalysisCenters.Create',
                        id: 'df8bae2a-b6c4-4fd7-a018-a9a74b52b3f5'
                    },
                    {
                        englishName: 'SupplierManagement.LabAnalysisCenters.DeActivate',
                        id: '430ac690-05db-42d6-86b7-d72a33ca1dde'
                    },
                    {
                        englishName: 'SupplierManagement.LabAnalysisCenters.Activate',
                        id: 'c66b5a37-6ad6-492c-9264-e05cdc8f508f'
                    }
                ],
                permissionGroups: [],
                englishName: 'SupplierManagement.LabAnalysisCenters',
                id: '7bee8127-e996-41e9-8f0b-760187c26120'
            },
            {
                permissions: [
                    {
                        englishName: 'SupplierManagement.Doctors.Update',
                        id: '5d50565a-7eeb-4112-9849-1a08aaf0344f'
                    },
                    {
                        englishName: 'SupplierManagement.Doctors.DeActivate',
                        id: 'a9ea8de1-b394-4abd-9f0f-2be6f5bcd847'
                    },
                    {
                        englishName: 'SupplierManagement.Doctors.Activate',
                        id: '727aa3e8-2be4-4990-83b2-9157441a5d2b'
                    },
                    {
                        englishName: 'SupplierManagement.Doctors.ReadAll',
                        id: 'a678ff21-118d-4eb5-bebd-99912c11329b'
                    },
                    {
                        englishName: 'SupplierManagement.Doctors.Read',
                        id: 'fabccf5e-6097-413f-a08a-b738f9545047'
                    },
                    {
                        englishName: 'SupplierManagement.Doctors.Create',
                        id: 'feec1240-a93c-4379-ac5e-d15c17479d05'
                    }
                ],
                permissionGroups: [],
                englishName: 'SupplierManagement.Doctors',
                id: '6b9a3686-c703-4715-8095-f7ca521df1ec'
            }
        ],
        englishName: 'SupplierManagement',
        id: 'aac4ae5f-eb60-434b-a33e-65c01dfa1bcb'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'PharmacyManagement.Pharmacies.Update',
                        id: '55330036-31bd-430c-bb2d-21b4c085a1be'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.Activate',
                        id: '1b6748a2-4373-4323-ab7d-541329c87eb6'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.Create',
                        id: '789b283a-1771-4657-8a03-54f6499bdbad'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.Read',
                        id: '86ff842d-052f-4fc4-8991-7641770f71f6'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.ReadAll',
                        id: '557022c4-588e-44b6-ba88-9914a65f5242'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.DeActivate',
                        id: '9be8d543-ea15-4749-84be-c9b3aab43b48'
                    }
                ],
                permissionGroups: [],
                englishName: 'PharmacyManagement.Pharmacies',
                id: 'db47b6bb-84ed-43d8-875c-77ca4cacffa4'
            },
            {
                permissions: [
                    {
                        englishName: 'PharmacyManagement.Drugs.DeActivate',
                        id: 'a681a6df-bbc4-41ea-b0ad-3198edd62d94'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.Update',
                        id: '768611c6-e843-4b69-9cf2-3f70ea32daf4'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.Read',
                        id: '25570174-caaf-42a6-ba90-4fb055b9098a'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.Activate',
                        id: 'cee25e85-f603-427d-9f5d-56167bf37bab'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.ReadAll',
                        id: '86d621ca-a67c-4d35-8c60-91e950ba2964'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.Create',
                        id: '96e09cf0-fd08-4740-9599-f53ee8d86513'
                    }
                ],
                permissionGroups: [],
                englishName: 'PharmacyManagement.Drugs',
                id: 'aacc7459-dbe1-46a5-86e8-963953ecb383'
            }
        ],
        englishName: 'PharmacyManagement',
        id: 'b65f36e6-c6ab-46f4-89a6-35727d719928'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'OrderManagement.Orders.Create',
                        id: '217e5308-1505-456d-94ec-b391ba353671'
                    }
                ],
                permissionGroups: [],
                englishName: 'OrderManagement.Orders',
                id: '00445a64-4b1b-41cc-9413-09251ca1b645'
            }
        ],
        englishName: 'OrderManagement',
        id: '9f209a73-b587-4a15-bde3-36a95d7b334f'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'CaseManagement.Cases.EndCall',
                        id: 'a22e7d42-c73f-4d07-ae16-0de9851d892e'
                    },
                    {
                        englishName: 'CaseManagement.Cases.RemoveAttachment',
                        id: 'e0053dc2-cda8-4652-9759-10d073377655'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Create',
                        id: '3fa6bab6-db2d-4f9e-bec5-1e94be963694'
                    },
                    {
                        englishName: 'CaseManagement.Cases.AddAttachment',
                        id: 'e0ffaf78-68d0-4f94-884e-1efd653e6b10'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Cancel',
                        id: '21ebccfb-abe6-4904-97dc-5ada551ebc8b'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Update',
                        id: '6afae9b6-2199-448c-94f4-642f38ffcad6'
                    },
                    {
                        englishName: 'CaseManagement.Cases.ReadMyCases',
                        id: 'e8e6947a-72df-4b48-9b42-6cf7dbd252e0'
                    },
                    {
                        englishName: 'CaseManagement.Cases.ReadCaseLookups',
                        id: 'f2107453-a65b-4f82-ab40-70a59bc8b943'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Delete',
                        id: 'ced1e28f-78a6-40ab-ac1d-75618e1ffbe1'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Pick',
                        id: '66b7aa51-d7fa-4deb-9d41-8c0617b32c3e'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Read',
                        id: '411cebad-7e70-41fc-9936-8cd4d36cf791'
                    },
                    {
                        englishName: 'CaseManagement.Cases.StartCall',
                        id: '30342126-53dd-4f4e-934e-a3f6589ed24c'
                    },
                    {
                        englishName: 'CaseManagement.Cases.ReadAll',
                        id: '1dff54b1-e933-45aa-924c-cc7a72e38b2f'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Resolve',
                        id: '020c6090-7f57-494c-8fff-e7667afdc8fc'
                    }
                ],
                permissionGroups: [],
                englishName: 'CaseManagement.Cases',
                id: '73f52636-ea03-4ec3-8709-8dc0bec9757d'
            },
            {
                permissions: [
                    {
                        englishName: 'CaseManagement.CaseRecommendations.Delete',
                        id: 'ea31c0e7-e76b-4717-9d70-d300da299aa5'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Create',
                                id: '0e4eb164-e38c-48b5-98ee-0706bccea907'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Update',
                                id: '42d38b3f-f651-4ef5-a253-1d7c14479592'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations',
                        id: 'd8d7c82f-c43b-4b11-af75-0009369e627a'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Update',
                                id: 'b699c3cc-3b84-472c-9a71-1bd69bed8517'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Create',
                                id: 'b4d06bdb-e001-4dcf-afd1-6b49664e31d4'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations',
                        id: '3d00aaf7-91f6-4120-9480-1018a88dac68'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Update',
                                id: '1c6b03f3-5c50-4b75-93cf-118e387ad2be'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Create',
                                id: '7bf9eaf0-47f3-45e6-9e7a-7f170c8059e0'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations',
                        id: '53cc514a-5934-4a9d-8088-89f8db8c9002'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Create',
                                id: 'ebefb79c-9b21-4f60-b38f-a164014a6ccb'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Update',
                                id: '19a2d252-035f-42ee-a05b-f40324cd8c8e'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations',
                        id: '5582b7c6-13d8-4a79-a95e-bee86b7daad6'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Create',
                                id: 'af333a35-a549-4e23-98c9-027bc5157377'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Update',
                                id: '7924de40-f0d3-40a1-921e-495d9fd9ec2b'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations',
                        id: '5b4536a2-85af-4104-8116-d1915dafffd4'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Read',
                                id: '094fc957-729d-49e6-b2b0-31b32c2eca95'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Create',
                                id: '9d4424d3-bf62-4604-bb4d-52ba1f0eed57'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Update',
                                id: '2ef4b62e-1f7f-46fe-ab3a-9987cc59c4e0'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations',
                        id: '3cd46e08-504a-4aca-8a14-fcd2f54e529b'
                    }
                ],
                englishName: 'CaseManagement.CaseRecommendations',
                id: '527dcb0a-45df-42a4-9ecb-eb6a22bea560'
            }
        ],
        englishName: 'CaseManagement',
        id: 'bc1cddaa-8f78-47be-b209-4e305e04561b'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.Diseases.ReadAll',
                        id: '249b889e-f817-4dc2-b80d-22ec5810110c'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.DeActivate',
                        id: '78242583-cb1e-4476-963d-294d96933928'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Update',
                        id: '83a170d5-2ad5-466b-bc1b-4b84b26cac5e'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Activate',
                        id: '02614f09-8bf7-44a7-bc09-7b7e577a362d'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Create',
                        id: '74e8ba99-ad1e-4051-a3a6-802669b1c033'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Import',
                        id: '437b773d-7af4-4525-a25e-b12410eaf65a'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Read',
                        id: 'e10e80a2-88f0-47d9-93c4-ba4dd72a136e'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.DeActivate',
                                id: 'a8982b4f-f48f-49bf-a46a-0bdfc1ac8fbd'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.Read',
                                id: '667ae670-0289-4ea9-8105-470d3b20b7bb'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.Update',
                                id: '6e1ff856-8a55-4482-ab95-571b559eef45'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.ReadAll',
                                id: '9f2b13dc-28fd-466d-86c3-809bd3c5c699'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.Create',
                                id: '955bd1b5-59dc-4414-ba6b-8bce6aab4bb5'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.Activate',
                                id: 'e3377c20-7833-4fad-90f3-bff7fd057a64'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.Diseases.DiseaseCategories',
                        id: '062d5111-b0c9-4efe-a890-236bb5d9440e'
                    }
                ],
                englishName: 'PatientManagement.Diseases',
                id: '2e64c152-fff7-4593-8a73-0e5a82039b8a'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.Symptoms.AddDrug',
                        id: '16cd0f8b-2f46-455c-a18c-0567c9ca65e8'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Activate',
                        id: 'adad8872-525b-45d0-9e0d-28ee8d20e34a'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Import',
                        id: 'ce3f1ce2-b18d-4670-a042-4c45d4f603e5'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Update',
                        id: '51ed84ed-fd0c-4e4d-b65e-645e6ad2a0ff'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Create',
                        id: '10ba20f2-a7d9-493e-8ef1-6cf867c93f4d'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.DeActivate',
                        id: '066d433d-c011-4d2e-a043-9ca5c6a824fa'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.RemoveDrug',
                        id: '0d7c62d7-6684-4d8b-9221-a6d1699ff047'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Read',
                        id: '1f44904d-c057-4314-af83-e7bd8a7f796e'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.ReadAll',
                        id: 'afc51135-5f30-4d2e-ad7d-f0ae2366bca7'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.Read',
                                id: 'bd79724f-418c-4e2d-94b0-205d1c9db44a'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.Activate',
                                id: '2a8705e0-bcf0-4aa6-8c1a-939f394c5e95'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.DeActivate',
                                id: 'f0295d6b-ac29-4fa1-923f-bca8ffc09b5f'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.Update',
                                id: 'c55bde73-0f5f-4d3f-a892-dc8e952135bf'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.ReadAll',
                                id: 'b1ed1ed8-20b8-4bb6-9a7b-e1b07ccdff16'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.Create',
                                id: '659f5fa5-5739-4225-8cfa-ee1deb64bee5'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.Symptoms.SymptomCategories',
                        id: '47f3ab3e-8b60-4073-b27a-5910827fe433'
                    }
                ],
                englishName: 'PatientManagement.Symptoms',
                id: 'b1bb0680-9a0d-4616-933a-284df197edfb'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.PatientProfiles.Statistics',
                        id: '694846d6-b06a-4cc4-a6fe-1258f2dc2615'
                    },
                    {
                        englishName: 'PatientManagement.PatientProfiles.Update',
                        id: 'd6d05f7b-00bd-40aa-8e5b-2cb7651d68f7'
                    },
                    {
                        englishName: 'PatientManagement.PatientProfiles.Create',
                        id: 'fe6f8b1a-8c55-4848-89d3-3c0f00fdd33e'
                    },
                    {
                        englishName: 'PatientManagement.PatientProfiles.Read',
                        id: '3f789772-4b3d-400f-a33f-891b8db6fcd8'
                    },
                    {
                        englishName: 'PatientManagement.PatientProfiles.ReadAll',
                        id: '54fc4d8e-697a-4a50-a4c9-936decc0f8aa'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.ReadAll',
                                id: 'b7a2151f-eb66-45e2-90e5-16a3c193c146'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Update',
                                id: '9c053b93-d544-4780-b564-1fa44f1fc786'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Read',
                                id: '05c3e16e-7b50-4d12-bc07-8d8cc20103ef'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Delete',
                                id: '119def5a-1256-468c-81f5-9ce9c760315b'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Create',
                                id: 'a2c0440b-32e8-452e-bdda-d69ab8d79124'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientAddictions',
                        id: '51df6101-06e3-4484-8f21-01e3822d8b77'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Create',
                                id: 'b62c33ff-3c75-491a-a945-2182d67d85da'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Read',
                                id: '3512fef6-08ad-475e-af44-2c33d09ecf09'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Delete',
                                id: '2d64c944-82d2-47ba-94d6-c32e9115081d'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.ReadAll',
                                id: 'fc3d6ea2-3624-4e2b-8323-cfc368a15650'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Update',
                                id: 'bf98d01d-cd72-4218-994e-dc6329ce02b7'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientSurgeries',
                        id: '2fa021e9-34ed-44f2-9397-1694bd3fa0e4'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Delete',
                                id: 'c5c44250-bb73-418b-8a18-12996e44bf74'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Read',
                                id: '33da1eda-a6c9-4b8a-bc81-5cc72fcc919a'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Update',
                                id: '5c520633-7a5f-467f-a92c-8c2f427d173a'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.ReadAll',
                                id: '5b5e4783-657e-4494-8849-ac8c8c92e10b'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Create',
                                id: '73b69ad3-4104-451e-9940-dfe8ee1e135a'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientSymptoms',
                        id: '318cf734-d99e-4d85-9422-33980f03aa6f'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Read',
                                id: '588c59a9-67f1-42aa-9c4f-1dec88605563'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAllergies.ReadAll',
                                id: '631d1b19-fca7-4e88-a8a1-48d41735108a'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Create',
                                id: 'd57cc304-6795-466d-aafb-63676b7e05ad'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Delete',
                                id: '514f3af3-bff3-4183-8fb3-8fc1f0fb203a'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientAllergies',
                        id: '2e55e9a1-5b51-41f8-86cc-4bb3521c16f6'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Delete',
                                id: 'a40189b7-61aa-42f3-ba19-1df055388f62'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Read',
                                id: 'a854e762-f331-4ffe-9e0e-5eaa3d08de0c'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Update',
                                id: 'b923f186-9824-4f21-8f79-764d232d1413'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Create',
                                id: '9defa263-edad-4277-91e3-7e0c26ebf2a2'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.ReadAll',
                                id: '158d2ff6-3d7d-4164-b263-d61a57d093b5'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts',
                        id: '1e98bd42-25e4-4b95-8dd0-4db7c4bf2042'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.ReadAll',
                                id: '3e11d782-383b-4a04-b040-267cd1d113bf'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Read',
                                id: '75e9c3c4-6126-41a9-a742-34c9fb7655f7'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Update',
                                id: '82d7dcae-2d3b-485d-bcd7-50bc3c45a88d'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Delete',
                                id: 'ecb441de-a559-41d3-8dee-78c586dcfed6'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Create',
                                id: '754365c7-de5c-4084-959b-8d917e17b09e'
                            }
                        ],
                        permissionGroups: [
                            {
                                permissions: [
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Update',
                                        id: '360c9360-6a6e-4427-b3f5-cbd2e9f38cd3'
                                    },
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Create',
                                        id: '763d7c27-46ad-4d71-8fb6-e98712d81b3e'
                                    },
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Delete',
                                        id: 'a2c5de95-8dfa-4075-9273-ee92715044e8'
                                    }
                                ],
                                permissionGroups: [],
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays',
                                id: '944a46f7-46c3-41af-8794-68915af4ea0c'
                            }
                        ],
                        englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits',
                        id: '5c03fbcc-bfaf-4550-be56-53aff5a4b583'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.Create',
                                id: 'a7cc6022-5fe8-41f0-b542-a91287a1453f'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.ReadAll',
                                id: 'af68825e-7aff-41bc-a437-eff7e7d467d7'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles',
                        id: '979cb20a-8a5a-4ab8-b847-fe590e273063'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Update',
                                id: 'a29db1b6-0517-486e-80ca-479a74e4ff76'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Read',
                                id: 'f631c57c-b05c-420a-ab89-800d5d9abbaa'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Delete',
                                id: 'e90a7cba-30c3-4b93-8e42-df40763541fb'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.ReadAll',
                                id: '05c8bd51-49e5-4f82-9f3d-ec062f857535'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Create',
                                id: '2b0091e3-780f-412f-a2f3-f45a73423573'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks',
                        id: '2c54200e-114e-4888-914c-5570518068d2'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Create',
                                id: 'e5b39d67-d61c-4462-b1c1-0d94efee4ea0'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.ReadAll',
                                id: 'ad906cbd-3f3b-448e-9330-32a84af1fcdb'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Delete',
                                id: '79e32887-89fa-4444-addd-ac5db6113b6a'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Read',
                                id: 'b2279996-fc54-4da5-b9e5-e72db6e45fae'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Update',
                                id: '24217931-706d-4a5f-905b-f9753e9c5bc9'
                            }
                        ],
                        permissionGroups: [
                            {
                                permissions: [
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Create',
                                        id: '047b6bb6-4f1a-468c-a60a-d8f30134e834'
                                    },
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Delete',
                                        id: '9e1255f9-7fe9-451a-b200-e4bc3ea346cd'
                                    },
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Update',
                                        id: '004670b3-1afd-433b-a851-ee36f8fdf496'
                                    }
                                ],
                                permissionGroups: [],
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses',
                                id: '066ab30c-79d6-4741-b82f-39c3d878ab2e'
                            }
                        ],
                        englishName: 'PatientManagement.PatientProfiles.PatientLabVisits',
                        id: '901acaad-8fb2-4791-a5a8-9ff2ffe721d1'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveAttachment',
                                id: 'ced94829-9cd4-4fe4-b8a1-068912b2491c'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddDrug',
                                id: '601a9705-16e8-4bbc-8a6b-29dec97fc40d'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Delete',
                                id: '82a965b1-59cd-422f-9f13-2fa8a1f67929'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.ReadAll',
                                id: 'eae819d0-e395-4a01-a908-55a34f61a724'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Create',
                                id: '61f9967e-873a-415f-b04d-a8a31fe0f1d4'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveDrug',
                                id: 'fa841b19-1dc3-471e-9dc1-c5a37c7b542b'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddAttachment',
                                id: '94f803bd-e401-464b-a0a6-e24ed142b033'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Update',
                                id: '4fc3327d-e2b1-46c7-95f0-f15d849ba1f3'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Read',
                                id: '86c3afde-0afd-4c61-a3dd-fff3e0378911'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientDiseases',
                        id: 'e1036f02-bb2d-47c1-8b78-adbaccbea685'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Read',
                                id: 'b5f2bfac-a892-43f1-b8d2-3ac7e15d2cad'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Update',
                                id: '771761e3-a605-4283-8ece-5ad9743cd8fa'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Create',
                                id: 'fb3f2fb1-fd2b-43d1-b88f-60bd4394d780'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Delete',
                                id: '6628f729-f87b-4f11-b3a6-c73a15c99de6'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.ReadAll',
                                id: '5d8aa804-edee-432a-912e-d7d8a04a5d45'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks',
                        id: '3582399b-927a-4ee2-8054-c0ea7f6912e9'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Read',
                                id: '86163100-91c0-4ef4-9a64-50edd3561178'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.ReadAll',
                                id: '01f0f288-a72b-44dd-90e6-6618faf83499'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Delete',
                                id: '21a9e432-c07b-41c4-be0e-910000462aa0'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Create',
                                id: 'ffb7b2c6-2e8c-4a91-9824-97e5ee18337b'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Update',
                                id: '7ad641cf-76d6-4a97-a47b-a2c170782bc6'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks',
                        id: '846a72ea-6562-41b0-a196-d5aeecabf53d'
                    }
                ],
                englishName: 'PatientManagement.PatientProfiles',
                id: '4803df5a-9b15-412d-9d63-3770c1d62a78'
            }
        ],
        englishName: 'PatientManagement',
        id: '4a3f7a29-85a8-4c01-974c-c96df21345d3'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'UtilityManagement.Attachments.Read',
                        id: '5f3810cd-454c-4607-83ba-63d17dd4f5b8'
                    },
                    {
                        englishName: 'UtilityManagement.Attachments.Create',
                        id: '4c373083-8d5d-496b-ad79-f5378c15cbdf'
                    }
                ],
                permissionGroups: [],
                englishName: 'UtilityManagement.Attachments',
                id: 'ad99d6ec-cb1e-4dd7-afbf-8bf1be54e8c2'
            }
        ],
        englishName: 'UtilityManagement',
        id: 'b6279d42-6a58-4a08-9e4d-caf27ae6a98d'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'UserManagement.Scopes.Create',
                        id: '9c4eeee1-c319-4860-ae0b-0889de1f9d71'
                    },
                    {
                        englishName: 'UserManagement.Scopes.Update',
                        id: '00f6f6d5-9e6d-4841-8ff3-7b2807461b01'
                    },
                    {
                        englishName: 'UserManagement.Scopes.Read',
                        id: '6baa6812-db1e-4483-a048-8336ee7a5c5d'
                    },
                    {
                        englishName: 'UserManagement.Scopes.ReadAll',
                        id: 'b59a5f3e-43c6-4d38-91c9-83f26bec3728'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'UserManagement.Scopes.Permissions.ReadAll',
                                id: 'e7ec29a3-e249-427a-a147-609dba2a3c56'
                            },
                            {
                                englishName: 'UserManagement.Scopes.Permissions.Assign',
                                id: 'cb01624e-8921-460a-8be4-6166a9c9e77e'
                            },
                            {
                                englishName: 'UserManagement.Scopes.Permissions.Revoke',
                                id: '963b1b2a-b1be-4786-9d17-e38c6bf7a668'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'UserManagement.Scopes.Permissions',
                        id: '76698ffb-43f3-4349-b81c-26257897989a'
                    }
                ],
                englishName: 'UserManagement.Scopes',
                id: '59d1eacb-357f-403d-8f88-199ff04aff47'
            },
            {
                permissions: [
                    {
                        englishName: 'UserManagement.Permissions.ReadAll',
                        id: 'fedb7c11-2bed-4a34-8615-a959f0a7bf8d'
                    }
                ],
                permissionGroups: [],
                englishName: 'UserManagement.Permissions',
                id: 'e5509f62-bf5f-4c5c-a2aa-50671af053f2'
            },
            {
                permissions: [
                    {
                        englishName: 'UserManagement.Users.ReadAll',
                        id: '9f8c6ca4-2ebc-4623-bc07-3392d30bb57e'
                    },
                    {
                        englishName: 'UserManagement.Users.Read',
                        id: '900caa49-7896-4f2b-924c-69a37522c63f'
                    }
                ],
                permissionGroups: [],
                englishName: 'UserManagement.Users',
                id: '9727d0bb-4a3f-4ba3-a2c4-8e40f394aa4d'
            },
            {
                permissions: [
                    {
                        englishName: 'UserManagement.Accounts.Create',
                        id: '18528eff-6e23-4a9e-8f70-161681165191'
                    },
                    {
                        englishName: 'UserManagement.Accounts.ReadAll',
                        id: '569b4871-fde0-4530-842d-27dd4b509c2c'
                    },
                    {
                        englishName: 'UserManagement.Accounts.Read',
                        id: '37706f0d-4990-437a-8e14-2eb836cea4bc'
                    },
                    {
                        englishName: 'UserManagement.Accounts.Update',
                        id: '2e333061-eca4-407a-846f-e93eae2a764c'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'UserManagement.Accounts.Users.Update',
                                id: '994db9a5-b51e-4acf-b2a1-047b3a77686a'
                            },
                            {
                                englishName: 'UserManagement.Accounts.Users.Create',
                                id: 'd40e4e0e-707d-4a95-b898-1a0a1b04590a'
                            },
                            {
                                englishName: 'UserManagement.Accounts.Users.ChangePassword',
                                id: '320f6500-158d-4be6-9cac-292bded067af'
                            },
                            {
                                englishName: 'UserManagement.Accounts.Users.ReadAll',
                                id: '38b29941-82d1-4ef2-a587-84b783ea23fa'
                            },
                            {
                                englishName: 'UserManagement.Accounts.Users.Read',
                                id: 'f2ca6f45-96de-406a-8209-cc89a811a399'
                            }
                        ],
                        permissionGroups: [
                            {
                                permissions: [
                                    {
                                        englishName: 'UserManagement.Accounts.Users.SpecializedRoles.Revoke',
                                        id: 'e10db11c-6092-4613-9aa0-23ff6a15b557'
                                    },
                                    {
                                        englishName: 'UserManagement.Accounts.Users.SpecializedRoles.Assign',
                                        id: '428a1fe9-5b9a-4899-acb5-8c73105912d3'
                                    }
                                ],
                                permissionGroups: [],
                                englishName: 'UserManagement.Accounts.Users.SpecializedRoles',
                                id: 'b78597fd-f209-4e60-9faf-9829cf3393f4'
                            }
                        ],
                        englishName: 'UserManagement.Accounts.Users',
                        id: '20a97415-f0d8-4623-9f67-30bfc5616c1b'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'UserManagement.Accounts.Scopes.Assign',
                                id: '77622d55-69c9-4a30-85a1-526f0a7ff876'
                            },
                            {
                                englishName: 'UserManagement.Accounts.Scopes.Revoke',
                                id: '5ca73435-5652-4221-ab70-b358c2da0321'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'UserManagement.Accounts.Scopes',
                        id: 'd55fbe10-7a11-4617-810f-d1fc0662fcc8'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'UserManagement.Accounts.SpecializedRoles.Update',
                                id: '9492a7d4-3c45-496f-964b-0e3ff5ff3a25'
                            },
                            {
                                englishName: 'UserManagement.Accounts.SpecializedRoles.ReadAll',
                                id: '8b4f999d-82bf-499a-999e-4b07734146d1'
                            },
                            {
                                englishName: 'UserManagement.Accounts.SpecializedRoles.Read',
                                id: '0b08ba69-231b-4501-923c-661636f7b688'
                            },
                            {
                                englishName: 'UserManagement.Accounts.SpecializedRoles.Create',
                                id: 'ba51e58e-a50b-49f7-9c43-c58e0cf409ae'
                            }
                        ],
                        permissionGroups: [
                            {
                                permissions: [
                                    {
                                        englishName: 'UserManagement.Accounts.SpecializedRoles.Permissions.Revoke',
                                        id: 'f704c0d6-f616-4c84-b54c-700ad73d72af'
                                    },
                                    {
                                        englishName: 'UserManagement.Accounts.SpecializedRoles.Permissions.Assign',
                                        id: '7b868dd8-bfc6-4b92-a67f-8f5b7913dd4d'
                                    },
                                    {
                                        englishName: 'UserManagement.Accounts.SpecializedRoles.Permissions.ReadAll',
                                        id: '0b8c2a28-ffa2-4de0-8ac5-fc93c551d85a'
                                    }
                                ],
                                permissionGroups: [],
                                englishName: 'UserManagement.Accounts.SpecializedRoles.Permissions',
                                id: 'd39d7374-0bef-4cc9-bfd3-64740585d8f0'
                            }
                        ],
                        englishName: 'UserManagement.Accounts.SpecializedRoles',
                        id: 'e187c64b-8101-4b48-8b5c-e128861683a0'
                    }
                ],
                englishName: 'UserManagement.Accounts',
                id: '88f5a1a0-6011-4652-b057-9dd0f85166ae'
            },
            {
                permissions: [
                    {
                        englishName: 'UserManagement.SystemRoles.ReadAll',
                        id: '24e1ef6b-cd95-4960-8783-84f2ecdd4018'
                    }
                ],
                permissionGroups: [],
                englishName: 'UserManagement.SystemRoles',
                id: '4c85c0e4-f3a0-4ae0-8de7-fbc0d2deae23'
            }
        ],
        englishName: 'UserManagement',
        id: '22be515e-afef-4de3-8711-2c4d8d5a89c4'
    }
];

export let assignedPermissionsTestData: IPermissionGroup[] = [
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'PharmacyManagement.Pharmacies.Update',
                        id: '55330036-31bd-430c-bb2d-21b4c085a1be'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.Activate',
                        id: '1b6748a2-4373-4323-ab7d-541329c87eb6'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.Create',
                        id: '789b283a-1771-4657-8a03-54f6499bdbad'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.Read',
                        id: '86ff842d-052f-4fc4-8991-7641770f71f6'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.ReadAll',
                        id: '557022c4-588e-44b6-ba88-9914a65f5242'
                    },
                    {
                        englishName: 'PharmacyManagement.Pharmacies.DeActivate',
                        id: '9be8d543-ea15-4749-84be-c9b3aab43b48'
                    }
                ],
                permissionGroups: [],
                englishName: 'PharmacyManagement.Pharmacies',
                id: 'db47b6bb-84ed-43d8-875c-77ca4cacffa4'
            },
            {
                permissions: [
                    {
                        englishName: 'PharmacyManagement.Drugs.DeActivate',
                        id: 'a681a6df-bbc4-41ea-b0ad-3198edd62d94'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.Update',
                        id: '768611c6-e843-4b69-9cf2-3f70ea32daf4'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.Read',
                        id: '25570174-caaf-42a6-ba90-4fb055b9098a'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.Activate',
                        id: 'cee25e85-f603-427d-9f5d-56167bf37bab'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.ReadAll',
                        id: '86d621ca-a67c-4d35-8c60-91e950ba2964'
                    },
                    {
                        englishName: 'PharmacyManagement.Drugs.Create',
                        id: '96e09cf0-fd08-4740-9599-f53ee8d86513'
                    }
                ],
                permissionGroups: [],
                englishName: 'PharmacyManagement.Drugs',
                id: 'aacc7459-dbe1-46a5-86e8-963953ecb383'
            }
        ],
        englishName: 'PharmacyManagement',
        id: 'b65f36e6-c6ab-46f4-89a6-35727d719928'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'CaseManagement.Cases.EndCall',
                        id: 'a22e7d42-c73f-4d07-ae16-0de9851d892e'
                    },
                    {
                        englishName: 'CaseManagement.Cases.RemoveAttachment',
                        id: 'e0053dc2-cda8-4652-9759-10d073377655'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Create',
                        id: '3fa6bab6-db2d-4f9e-bec5-1e94be963694'
                    },
                    {
                        englishName: 'CaseManagement.Cases.AddAttachment',
                        id: 'e0ffaf78-68d0-4f94-884e-1efd653e6b10'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Cancel',
                        id: '21ebccfb-abe6-4904-97dc-5ada551ebc8b'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Update',
                        id: '6afae9b6-2199-448c-94f4-642f38ffcad6'
                    },
                    {
                        englishName: 'CaseManagement.Cases.ReadMyCases',
                        id: 'e8e6947a-72df-4b48-9b42-6cf7dbd252e0'
                    },
                    {
                        englishName: 'CaseManagement.Cases.ReadCaseLookups',
                        id: 'f2107453-a65b-4f82-ab40-70a59bc8b943'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Delete',
                        id: 'ced1e28f-78a6-40ab-ac1d-75618e1ffbe1'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Pick',
                        id: '66b7aa51-d7fa-4deb-9d41-8c0617b32c3e'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Read',
                        id: '411cebad-7e70-41fc-9936-8cd4d36cf791'
                    },
                    {
                        englishName: 'CaseManagement.Cases.StartCall',
                        id: '30342126-53dd-4f4e-934e-a3f6589ed24c'
                    },
                    {
                        englishName: 'CaseManagement.Cases.ReadAll',
                        id: '1dff54b1-e933-45aa-924c-cc7a72e38b2f'
                    },
                    {
                        englishName: 'CaseManagement.Cases.Resolve',
                        id: '020c6090-7f57-494c-8fff-e7667afdc8fc'
                    }
                ],
                permissionGroups: [],
                englishName: 'CaseManagement.Cases',
                id: '73f52636-ea03-4ec3-8709-8dc0bec9757d'
            },
            {
                permissions: [
                    {
                        englishName: 'CaseManagement.CaseRecommendations.Delete',
                        id: 'ea31c0e7-e76b-4717-9d70-d300da299aa5'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Create',
                                id: '0e4eb164-e38c-48b5-98ee-0706bccea907'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations.Update',
                                id: '42d38b3f-f651-4ef5-a253-1d7c14479592'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.XrayVisitRecommendations',
                        id: 'd8d7c82f-c43b-4b11-af75-0009369e627a'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Update',
                                id: 'b699c3cc-3b84-472c-9a71-1bd69bed8517'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations.Create',
                                id: 'b4d06bdb-e001-4dcf-afd1-6b49664e31d4'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.VisitHospitalRecommendations',
                        id: '3d00aaf7-91f6-4120-9480-1018a88dac68'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Update',
                                id: '1c6b03f3-5c50-4b75-93cf-118e387ad2be'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations.Create',
                                id: '7bf9eaf0-47f3-45e6-9e7a-7f170c8059e0'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.InstructionsRecommendations',
                        id: '53cc514a-5934-4a9d-8088-89f8db8c9002'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Create',
                                id: 'ebefb79c-9b21-4f60-b38f-a164014a6ccb'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations.Update',
                                id: '19a2d252-035f-42ee-a05b-f40324cd8c8e'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.VisitSpecializedDoctorRecommendations',
                        id: '5582b7c6-13d8-4a79-a95e-bee86b7daad6'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Create',
                                id: 'af333a35-a549-4e23-98c9-027bc5157377'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations.Update',
                                id: '7924de40-f0d3-40a1-921e-495d9fd9ec2b'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.LabVisitRecommendations',
                        id: '5b4536a2-85af-4104-8116-d1915dafffd4'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Read',
                                id: '094fc957-729d-49e6-b2b0-31b32c2eca95'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Create',
                                id: '9d4424d3-bf62-4604-bb4d-52ba1f0eed57'
                            },
                            {
                                englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations.Update',
                                id: '2ef4b62e-1f7f-46fe-ab3a-9987cc59c4e0'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'CaseManagement.CaseRecommendations.CaseMedicationsRecommendations',
                        id: '3cd46e08-504a-4aca-8a14-fcd2f54e529b'
                    }
                ],
                englishName: 'CaseManagement.CaseRecommendations',
                id: '527dcb0a-45df-42a4-9ecb-eb6a22bea560'
            }
        ],
        englishName: 'CaseManagement',
        id: 'bc1cddaa-8f78-47be-b209-4e305e04561b'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.Diseases.ReadAll',
                        id: '249b889e-f817-4dc2-b80d-22ec5810110c'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.DeActivate',
                        id: '78242583-cb1e-4476-963d-294d96933928'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Update',
                        id: '83a170d5-2ad5-466b-bc1b-4b84b26cac5e'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Activate',
                        id: '02614f09-8bf7-44a7-bc09-7b7e577a362d'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Create',
                        id: '74e8ba99-ad1e-4051-a3a6-802669b1c033'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Import',
                        id: '437b773d-7af4-4525-a25e-b12410eaf65a'
                    },
                    {
                        englishName: 'PatientManagement.Diseases.Read',
                        id: 'e10e80a2-88f0-47d9-93c4-ba4dd72a136e'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.DeActivate',
                                id: 'a8982b4f-f48f-49bf-a46a-0bdfc1ac8fbd'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.Read',
                                id: '667ae670-0289-4ea9-8105-470d3b20b7bb'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.Update',
                                id: '6e1ff856-8a55-4482-ab95-571b559eef45'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.ReadAll',
                                id: '9f2b13dc-28fd-466d-86c3-809bd3c5c699'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.Create',
                                id: '955bd1b5-59dc-4414-ba6b-8bce6aab4bb5'
                            },
                            {
                                englishName: 'PatientManagement.Diseases.DiseaseCategories.Activate',
                                id: 'e3377c20-7833-4fad-90f3-bff7fd057a64'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.Diseases.DiseaseCategories',
                        id: '062d5111-b0c9-4efe-a890-236bb5d9440e'
                    }
                ],
                englishName: 'PatientManagement.Diseases',
                id: '2e64c152-fff7-4593-8a73-0e5a82039b8a'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.Symptoms.AddDrug',
                        id: '16cd0f8b-2f46-455c-a18c-0567c9ca65e8'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Activate',
                        id: 'adad8872-525b-45d0-9e0d-28ee8d20e34a'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Import',
                        id: 'ce3f1ce2-b18d-4670-a042-4c45d4f603e5'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Update',
                        id: '51ed84ed-fd0c-4e4d-b65e-645e6ad2a0ff'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Create',
                        id: '10ba20f2-a7d9-493e-8ef1-6cf867c93f4d'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.DeActivate',
                        id: '066d433d-c011-4d2e-a043-9ca5c6a824fa'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.RemoveDrug',
                        id: '0d7c62d7-6684-4d8b-9221-a6d1699ff047'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.Read',
                        id: '1f44904d-c057-4314-af83-e7bd8a7f796e'
                    },
                    {
                        englishName: 'PatientManagement.Symptoms.ReadAll',
                        id: 'afc51135-5f30-4d2e-ad7d-f0ae2366bca7'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.Read',
                                id: 'bd79724f-418c-4e2d-94b0-205d1c9db44a'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.Activate',
                                id: '2a8705e0-bcf0-4aa6-8c1a-939f394c5e95'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.DeActivate',
                                id: 'f0295d6b-ac29-4fa1-923f-bca8ffc09b5f'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.Update',
                                id: 'c55bde73-0f5f-4d3f-a892-dc8e952135bf'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.ReadAll',
                                id: 'b1ed1ed8-20b8-4bb6-9a7b-e1b07ccdff16'
                            },
                            {
                                englishName: 'PatientManagement.Symptoms.SymptomCategories.Create',
                                id: '659f5fa5-5739-4225-8cfa-ee1deb64bee5'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.Symptoms.SymptomCategories',
                        id: '47f3ab3e-8b60-4073-b27a-5910827fe433'
                    }
                ],
                englishName: 'PatientManagement.Symptoms',
                id: 'b1bb0680-9a0d-4616-933a-284df197edfb'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.Vaccines.Read',
                        id: '57ec279c-814b-4fe9-bca2-6abd500d20c4'
                    },
                    {
                        englishName: 'PatientManagement.Vaccines.ReadAll',
                        id: '86b741d9-ee81-4281-b900-8ca6f9cc61b9'
                    },
                    {
                        englishName: 'PatientManagement.Vaccines.Activate',
                        id: 'd46268ed-c016-4e55-ac8a-a680086788c2'
                    },
                    {
                        englishName: 'PatientManagement.Vaccines.DeActivate',
                        id: '7137b179-1a43-41a1-ae57-c3ef333ab978'
                    },
                    {
                        englishName: 'PatientManagement.Vaccines.Update',
                        id: 'ad0214e9-c93f-4862-8f5c-d6599c1ece0c'
                    },
                    {
                        englishName: 'PatientManagement.Vaccines.Create',
                        id: 'c4e9a64c-b52e-425e-bb70-df31739bf4c9'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.Vaccines.VaccineCategories.Read',
                                id: '7adb8034-bb44-40bd-a4f3-0a311f692d79'
                            },
                            {
                                englishName: 'PatientManagement.Vaccines.VaccineCategories.Create',
                                id: 'f31d4717-660e-4074-8c2e-7a0ad89747a9'
                            },
                            {
                                englishName: 'PatientManagement.Vaccines.VaccineCategories.Update',
                                id: '2d9993f3-0ae3-4a36-bada-b0f0bd30837c'
                            },
                            {
                                englishName: 'PatientManagement.Vaccines.VaccineCategories.Activate',
                                id: '47d00052-5138-4f85-b0d7-b7696dfea6ec'
                            },
                            {
                                englishName: 'PatientManagement.Vaccines.VaccineCategories.ReadAll',
                                id: '9adc3d7d-ecdf-4084-92d8-e5a899344df2'
                            },
                            {
                                englishName: 'PatientManagement.Vaccines.VaccineCategories.DeActivate',
                                id: '0aeb112e-00d2-467f-9f0e-e9e72ea8e05d'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.Vaccines.VaccineCategories',
                        id: '59f7938b-7c01-4cd6-9279-ae639e98f833'
                    }
                ],
                englishName: 'PatientManagement.Vaccines',
                id: '9cb64beb-12e6-4d1c-ab36-3656de8a5a9c'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.PatientProfiles.Statistics',
                        id: '694846d6-b06a-4cc4-a6fe-1258f2dc2615'
                    },
                    {
                        englishName: 'PatientManagement.PatientProfiles.Update',
                        id: 'd6d05f7b-00bd-40aa-8e5b-2cb7651d68f7'
                    },
                    {
                        englishName: 'PatientManagement.PatientProfiles.Create',
                        id: 'fe6f8b1a-8c55-4848-89d3-3c0f00fdd33e'
                    },
                    {
                        englishName: 'PatientManagement.PatientProfiles.Read',
                        id: '3f789772-4b3d-400f-a33f-891b8db6fcd8'
                    },
                    {
                        englishName: 'PatientManagement.PatientProfiles.ReadAll',
                        id: '54fc4d8e-697a-4a50-a4c9-936decc0f8aa'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.ReadAll',
                                id: 'b7a2151f-eb66-45e2-90e5-16a3c193c146'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Update',
                                id: '9c053b93-d544-4780-b564-1fa44f1fc786'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Read',
                                id: '05c3e16e-7b50-4d12-bc07-8d8cc20103ef'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Delete',
                                id: '119def5a-1256-468c-81f5-9ce9c760315b'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAddictions.Create',
                                id: 'a2c0440b-32e8-452e-bdda-d69ab8d79124'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientAddictions',
                        id: '51df6101-06e3-4484-8f21-01e3822d8b77'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Create',
                                id: 'b62c33ff-3c75-491a-a945-2182d67d85da'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Read',
                                id: '3512fef6-08ad-475e-af44-2c33d09ecf09'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Delete',
                                id: '2d64c944-82d2-47ba-94d6-c32e9115081d'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.ReadAll',
                                id: 'fc3d6ea2-3624-4e2b-8323-cfc368a15650'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSurgeries.Update',
                                id: 'bf98d01d-cd72-4218-994e-dc6329ce02b7'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientSurgeries',
                        id: '2fa021e9-34ed-44f2-9397-1694bd3fa0e4'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Delete',
                                id: 'c5c44250-bb73-418b-8a18-12996e44bf74'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Read',
                                id: '33da1eda-a6c9-4b8a-bc81-5cc72fcc919a'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Update',
                                id: '5c520633-7a5f-467f-a92c-8c2f427d173a'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.ReadAll',
                                id: '5b5e4783-657e-4494-8849-ac8c8c92e10b'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientSymptoms.Create',
                                id: '73b69ad3-4104-451e-9940-dfe8ee1e135a'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientSymptoms',
                        id: '318cf734-d99e-4d85-9422-33980f03aa6f'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Read',
                                id: '588c59a9-67f1-42aa-9c4f-1dec88605563'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAllergies.ReadAll',
                                id: '631d1b19-fca7-4e88-a8a1-48d41735108a'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Create',
                                id: 'd57cc304-6795-466d-aafb-63676b7e05ad'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientAllergies.Delete',
                                id: '514f3af3-bff3-4183-8fb3-8fc1f0fb203a'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientAllergies',
                        id: '2e55e9a1-5b51-41f8-86cc-4bb3521c16f6'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Delete',
                                id: 'a40189b7-61aa-42f3-ba19-1df055388f62'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Read',
                                id: 'a854e762-f331-4ffe-9e0e-5eaa3d08de0c'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Update',
                                id: 'b923f186-9824-4f21-8f79-764d232d1413'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.Create',
                                id: '9defa263-edad-4277-91e3-7e0c26ebf2a2'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts.ReadAll',
                                id: '158d2ff6-3d7d-4164-b263-d61a57d093b5'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientEmergencyContacts',
                        id: '1e98bd42-25e4-4b95-8dd0-4db7c4bf2042'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.ReadAll',
                                id: '3e11d782-383b-4a04-b040-267cd1d113bf'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Read',
                                id: '75e9c3c4-6126-41a9-a742-34c9fb7655f7'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Update',
                                id: '82d7dcae-2d3b-485d-bcd7-50bc3c45a88d'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Delete',
                                id: 'ecb441de-a559-41d3-8dee-78c586dcfed6'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.Create',
                                id: '754365c7-de5c-4084-959b-8d917e17b09e'
                            }
                        ],
                        permissionGroups: [
                            {
                                permissions: [
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Update',
                                        id: '360c9360-6a6e-4427-b3f5-cbd2e9f38cd3'
                                    },
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Create',
                                        id: '763d7c27-46ad-4d71-8fb6-e98712d81b3e'
                                    },
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays.Delete',
                                        id: 'a2c5de95-8dfa-4075-9273-ee92715044e8'
                                    }
                                ],
                                permissionGroups: [],
                                englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits.PatientXrays',
                                id: '944a46f7-46c3-41af-8794-68915af4ea0c'
                            }
                        ],
                        englishName: 'PatientManagement.PatientProfiles.PatientXrayVisits',
                        id: '5c03fbcc-bfaf-4550-be56-53aff5a4b583'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.Create',
                                id: 'a7cc6022-5fe8-41f0-b542-a91287a1453f'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles.ReadAll',
                                id: 'af68825e-7aff-41bc-a437-eff7e7d467d7'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientRelatedProfiles',
                        id: '979cb20a-8a5a-4ab8-b847-fe590e273063'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Update',
                                id: 'a29db1b6-0517-486e-80ca-479a74e4ff76'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Read',
                                id: 'f631c57c-b05c-420a-ab89-800d5d9abbaa'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Delete',
                                id: 'e90a7cba-30c3-4b93-8e42-df40763541fb'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.ReadAll',
                                id: '05c8bd51-49e5-4f82-9f3d-ec062f857535'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks.Create',
                                id: '2b0091e3-780f-412f-a2f3-f45a73423573'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.BloodGlucoseChecks',
                        id: '2c54200e-114e-4888-914c-5570518068d2'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Create',
                                id: 'e5b39d67-d61c-4462-b1c1-0d94efee4ea0'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.ReadAll',
                                id: 'ad906cbd-3f3b-448e-9330-32a84af1fcdb'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Delete',
                                id: '79e32887-89fa-4444-addd-ac5db6113b6a'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Read',
                                id: 'b2279996-fc54-4da5-b9e5-e72db6e45fae'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.Update',
                                id: '24217931-706d-4a5f-905b-f9753e9c5bc9'
                            }
                        ],
                        permissionGroups: [
                            {
                                permissions: [
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Create',
                                        id: '047b6bb6-4f1a-468c-a60a-d8f30134e834'
                                    },
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Delete',
                                        id: '9e1255f9-7fe9-451a-b200-e4bc3ea346cd'
                                    },
                                    {
                                        englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses.Update',
                                        id: '004670b3-1afd-433b-a851-ee36f8fdf496'
                                    }
                                ],
                                permissionGroups: [],
                                englishName: 'PatientManagement.PatientProfiles.PatientLabVisits.PatientLabAnalyses',
                                id: '066ab30c-79d6-4741-b82f-39c3d878ab2e'
                            }
                        ],
                        englishName: 'PatientManagement.PatientProfiles.PatientLabVisits',
                        id: '901acaad-8fb2-4791-a5a8-9ff2ffe721d1'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveAttachment',
                                id: 'ced94829-9cd4-4fe4-b8a1-068912b2491c'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddDrug',
                                id: '601a9705-16e8-4bbc-8a6b-29dec97fc40d'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Delete',
                                id: '82a965b1-59cd-422f-9f13-2fa8a1f67929'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.ReadAll',
                                id: 'eae819d0-e395-4a01-a908-55a34f61a724'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Create',
                                id: '61f9967e-873a-415f-b04d-a8a31fe0f1d4'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.RemoveDrug',
                                id: 'fa841b19-1dc3-471e-9dc1-c5a37c7b542b'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.AddAttachment',
                                id: '94f803bd-e401-464b-a0a6-e24ed142b033'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Update',
                                id: '4fc3327d-e2b1-46c7-95f0-f15d849ba1f3'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.PatientDiseases.Read',
                                id: '86c3afde-0afd-4c61-a3dd-fff3e0378911'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.PatientDiseases',
                        id: 'e1036f02-bb2d-47c1-8b78-adbaccbea685'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Read',
                                id: 'b5f2bfac-a892-43f1-b8d2-3ac7e15d2cad'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Update',
                                id: '771761e3-a605-4283-8ece-5ad9743cd8fa'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Create',
                                id: 'fb3f2fb1-fd2b-43d1-b88f-60bd4394d780'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.Delete',
                                id: '6628f729-f87b-4f11-b3a6-c73a15c99de6'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks.ReadAll',
                                id: '5d8aa804-edee-432a-912e-d7d8a04a5d45'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.BloodPressureChecks',
                        id: '3582399b-927a-4ee2-8054-c0ea7f6912e9'
                    },
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Read',
                                id: '86163100-91c0-4ef4-9a64-50edd3561178'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.ReadAll',
                                id: '01f0f288-a72b-44dd-90e6-6618faf83499'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Delete',
                                id: '21a9e432-c07b-41c4-be0e-910000462aa0'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Create',
                                id: 'ffb7b2c6-2e8c-4a91-9824-97e5ee18337b'
                            },
                            {
                                englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks.Update',
                                id: '7ad641cf-76d6-4a97-a47b-a2c170782bc6'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.PatientProfiles.WeightHeightChecks',
                        id: '846a72ea-6562-41b0-a196-d5aeecabf53d'
                    }
                ],
                englishName: 'PatientManagement.PatientProfiles',
                id: '4803df5a-9b15-412d-9d63-3770c1d62a78'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.Surgeries.DeActivate',
                        id: '11e0a3b3-6ff2-4453-862c-3bd755a0d96e'
                    },
                    {
                        englishName: 'PatientManagement.Surgeries.ReadAll',
                        id: '696918c4-32ae-406f-be2b-6c92f1ae47ca'
                    },
                    {
                        englishName: 'PatientManagement.Surgeries.Activate',
                        id: '1beea311-64ff-4a10-91da-9441ca808d0c'
                    },
                    {
                        englishName: 'PatientManagement.Surgeries.Create',
                        id: '8b79b2e7-29e4-43ad-a555-946c02028852'
                    },
                    {
                        englishName: 'PatientManagement.Surgeries.Update',
                        id: 'd7a81e0c-70b2-4e29-9d45-b9c34c79cdd4'
                    },
                    {
                        englishName: 'PatientManagement.Surgeries.Read',
                        id: '2592f70b-1d1c-4489-af15-c4f72d41ede2'
                    },
                    {
                        englishName: 'PatientManagement.Surgeries.Import',
                        id: 'b562b595-a2c1-4a56-97da-d7a03942f648'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.Surgeries.SurgeryCategories.Read',
                                id: '17eb773b-c41b-4fc8-aeae-04f8dbf136e8'
                            },
                            {
                                englishName: 'PatientManagement.Surgeries.SurgeryCategories.Update',
                                id: 'e8f2ee61-442c-4e21-9f8f-13d897de5e44'
                            },
                            {
                                englishName: 'PatientManagement.Surgeries.SurgeryCategories.ReadAll',
                                id: '70d2aeec-3f1f-43aa-9172-158f4bc9aa45'
                            },
                            {
                                englishName: 'PatientManagement.Surgeries.SurgeryCategories.Create',
                                id: 'fb7b6ad0-b99b-4b40-b98c-69082ad7415f'
                            },
                            {
                                englishName: 'PatientManagement.Surgeries.SurgeryCategories.Activate',
                                id: '67976ebb-5d04-49cd-a9c3-9e3b9edc9258'
                            },
                            {
                                englishName: 'PatientManagement.Surgeries.SurgeryCategories.DeActivate',
                                id: '7d9b71b0-fa4e-4d96-b4ed-a65ff719da92'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.Surgeries.SurgeryCategories',
                        id: '8d0d6040-e037-4ceb-ac10-b6bc3d0f4f1b'
                    }
                ],
                englishName: 'PatientManagement.Surgeries',
                id: '3d45553c-4e15-4012-9bf2-72671bfc101e'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.Addictions.Update',
                        id: '67a2c27d-4940-41f1-8d02-1aacaeeeddc7'
                    },
                    {
                        englishName: 'PatientManagement.Addictions.Read',
                        id: '2bedd566-27fb-4851-ad54-1bc583607145'
                    },
                    {
                        englishName: 'PatientManagement.Addictions.DeActivate',
                        id: '0a62af4b-6367-4a24-b5b0-84903a6f0788'
                    },
                    {
                        englishName: 'PatientManagement.Addictions.Create',
                        id: '0b58083b-42b4-46af-b90c-92862a5560a3'
                    },
                    {
                        englishName: 'PatientManagement.Addictions.ReadAll',
                        id: '3f1335c2-3347-474f-8642-9fba6f34177c'
                    },
                    {
                        englishName: 'PatientManagement.Addictions.Activate',
                        id: '46683e03-028f-4313-b24b-bed65b4b3006'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.Addictions.AddictionCategories.Read',
                                id: '394cf76e-1671-483c-8366-2cc4dc637ac2'
                            },
                            {
                                englishName: 'PatientManagement.Addictions.AddictionCategories.Activate',
                                id: '473d2e0b-0cef-4105-9c87-7d3c00494712'
                            },
                            {
                                englishName: 'PatientManagement.Addictions.AddictionCategories.ReadAll',
                                id: '40f394f9-54fd-48a2-9297-94616660fb42'
                            },
                            {
                                englishName: 'PatientManagement.Addictions.AddictionCategories.DeActivate',
                                id: 'c6a9bdf0-8946-45be-b313-9931491ff74c'
                            },
                            {
                                englishName: 'PatientManagement.Addictions.AddictionCategories.Update',
                                id: 'fae52453-5047-4276-b96a-beb5a9e7ecdb'
                            },
                            {
                                englishName: 'PatientManagement.Addictions.AddictionCategories.Create',
                                id: 'b63c1430-f16a-4eaa-826e-e49ea0c9dba1'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.Addictions.AddictionCategories',
                        id: '7eb609da-2e75-43ff-b655-4c76d4d5099d'
                    }
                ],
                englishName: 'PatientManagement.Addictions',
                id: '1445018c-45c1-425d-8585-82eb516032ee'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.Allergies.Read',
                        id: 'bb1c5b8a-755c-400f-bb8e-25261787d616'
                    },
                    {
                        englishName: 'PatientManagement.Allergies.DeActivate',
                        id: '62bdd8ab-b554-48ec-9707-763a99dbe0f7'
                    },
                    {
                        englishName: 'PatientManagement.Allergies.ReadAll',
                        id: '6398187c-95ee-4539-8979-9c3626bc7be4'
                    },
                    {
                        englishName: 'PatientManagement.Allergies.Update',
                        id: '279dd610-fecf-4db1-8b1a-c1374ac9eed1'
                    },
                    {
                        englishName: 'PatientManagement.Allergies.Create',
                        id: 'e1e5ccdb-e4b2-4f04-ada5-d68b4523faa7'
                    },
                    {
                        englishName: 'PatientManagement.Allergies.Import',
                        id: '9c78e372-2b55-4e6f-98d9-d82298c3fa06'
                    },
                    {
                        englishName: 'PatientManagement.Allergies.Activate',
                        id: '80fe1be2-ace1-4082-bf85-ef41b88ca595'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.Allergies.AllergyCategories.Update',
                                id: 'f16ea026-f87f-48b7-968b-37fc21144f9e'
                            },
                            {
                                englishName: 'PatientManagement.Allergies.AllergyCategories.DeActivate',
                                id: 'd9233f68-3a90-4572-a40d-98ba4540f472'
                            },
                            {
                                englishName: 'PatientManagement.Allergies.AllergyCategories.ReadAll',
                                id: 'c0a11ace-ac43-421f-b23d-a2dcabf755bd'
                            },
                            {
                                englishName: 'PatientManagement.Allergies.AllergyCategories.Read',
                                id: 'e4d22a70-f1a4-49a0-b43b-eacc56cb771f'
                            },
                            {
                                englishName: 'PatientManagement.Allergies.AllergyCategories.Create',
                                id: 'a1c1bfff-f82d-4668-936a-f66306ae1e35'
                            },
                            {
                                englishName: 'PatientManagement.Allergies.AllergyCategories.Activate',
                                id: '3bcc1bc3-4c4f-494f-aa49-fa788787ff83'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.Allergies.AllergyCategories',
                        id: '3422a90b-f6ea-4739-b7e9-c88af03c7fd3'
                    }
                ],
                englishName: 'PatientManagement.Allergies',
                id: 'b4186678-14ee-468d-9fd3-8496f10d526a'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.LabAnalyses.Activate',
                        id: 'a5d3b488-f5b6-4f40-995d-479b9841045b'
                    },
                    {
                        englishName: 'PatientManagement.LabAnalyses.Read',
                        id: '9463837c-7bba-4e7f-a13e-7b8bf294117c'
                    },
                    {
                        englishName: 'PatientManagement.LabAnalyses.DeActivate',
                        id: '10309003-0436-403d-a502-8b8132c30270'
                    },
                    {
                        englishName: 'PatientManagement.LabAnalyses.Import',
                        id: '742c8286-ec3f-4eb5-b637-a76b565529e5'
                    },
                    {
                        englishName: 'PatientManagement.LabAnalyses.Update',
                        id: '308669e7-db92-4483-9a41-b21dd4b22bc1'
                    },
                    {
                        englishName: 'PatientManagement.LabAnalyses.ReadAll',
                        id: '6631d78f-7c5f-4ab1-9667-e531f7b757b4'
                    },
                    {
                        englishName: 'PatientManagement.LabAnalyses.Create',
                        id: '720051f4-c9c1-493a-902a-ff051afefaae'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.ReadAll',
                                id: '8727ef00-a37b-4982-a65e-06552c1e5bca'
                            },
                            {
                                englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Read',
                                id: '1bfc1652-7222-44a4-bf77-18d401b28520'
                            },
                            {
                                englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.DeActivate',
                                id: 'e59e77b0-b253-471d-b6c8-48163af5b3d9'
                            },
                            {
                                englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Create',
                                id: 'd0c0e883-51c2-4a90-98d4-aebea3d173e8'
                            },
                            {
                                englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Update',
                                id: '2912f18e-aca1-4503-a372-d9f6f3823a88'
                            },
                            {
                                englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories.Activate',
                                id: '26cd4197-0975-4be1-93bd-dcb3c1be73b0'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.LabAnalyses.LabAnalysisCategories',
                        id: '1a300400-e6c1-4137-a390-9c9248dffe44'
                    }
                ],
                englishName: 'PatientManagement.LabAnalyses',
                id: 'b71ad2e1-f0bc-4360-8879-b9e299a0fbbf'
            },
            {
                permissions: [
                    {
                        englishName: 'PatientManagement.XRays.ReadAll',
                        id: 'c1af76ec-17bb-44ec-bca1-2934e6856a97'
                    },
                    {
                        englishName: 'PatientManagement.XRays.Create',
                        id: 'a74b371c-4e45-4b0d-97e1-2c404e29baf1'
                    },
                    {
                        englishName: 'PatientManagement.XRays.Update',
                        id: '6973114c-01d7-4d3b-9a31-9cd2fa38e208'
                    },
                    {
                        englishName: 'PatientManagement.XRays.DeActivate',
                        id: '9578af38-31d2-4a64-864b-9f9d1b2eaef2'
                    },
                    {
                        englishName: 'PatientManagement.XRays.Import',
                        id: 'edecad61-a6ce-4bf5-8222-bc59d8c07265'
                    },
                    {
                        englishName: 'PatientManagement.XRays.Activate',
                        id: 'aec4e380-4266-4fcb-8529-df9404ee5698'
                    },
                    {
                        englishName: 'PatientManagement.XRays.Read',
                        id: '9c0b5f79-223e-4c26-a643-fbbe22309acd'
                    }
                ],
                permissionGroups: [
                    {
                        permissions: [
                            {
                                englishName: 'PatientManagement.XRays.XRayCategories.Update',
                                id: 'fd78db7e-020a-4273-b6ad-0f2da2434e86'
                            },
                            {
                                englishName: 'PatientManagement.XRays.XRayCategories.DeActivate',
                                id: '33250228-7977-45dc-9400-3ce9d0d58b5c'
                            },
                            {
                                englishName: 'PatientManagement.XRays.XRayCategories.Create',
                                id: '07b2c8e9-bc05-4f7d-80d0-6f946a8af688'
                            },
                            {
                                englishName: 'PatientManagement.XRays.XRayCategories.ReadAll',
                                id: '28bff4af-1892-4cf3-ae72-e34a203e7c51'
                            },
                            {
                                englishName: 'PatientManagement.XRays.XRayCategories.Activate',
                                id: '8a6e6e99-58d7-42e2-b0a5-fbc13bb8bf04'
                            },
                            {
                                englishName: 'PatientManagement.XRays.XRayCategories.Read',
                                id: '9c792b62-b65a-40fa-bf6a-fd450540af6e'
                            }
                        ],
                        permissionGroups: [],
                        englishName: 'PatientManagement.XRays.XRayCategories',
                        id: 'eadd7ad5-f4ca-4a0f-9368-081b94999267'
                    }
                ],
                englishName: 'PatientManagement.XRays',
                id: '784db467-3812-434b-8478-f77f8e4ff74f'
            }
        ],
        englishName: 'PatientManagement',
        id: '4a3f7a29-85a8-4c01-974c-c96df21345d3'
    },
    {
        permissions: [],
        permissionGroups: [
            {
                permissions: [
                    {
                        englishName: 'UtilityManagement.Attachments.Read',
                        id: '5f3810cd-454c-4607-83ba-63d17dd4f5b8'
                    },
                    {
                        englishName: 'UtilityManagement.Attachments.Create',
                        id: '4c373083-8d5d-496b-ad79-f5378c15cbdf'
                    }
                ],
                permissionGroups: [],
                englishName: 'UtilityManagement.Attachments',
                id: 'ad99d6ec-cb1e-4dd7-afbf-8bf1be54e8c2'
            }
        ],
        englishName: 'UtilityManagement',
        id: 'b6279d42-6a58-4a08-9e4d-caf27ae6a98d'
    }
];
